import { useDispatch, useSelector } from 'react-redux';
import { fetchUser } from './userSlice';

export const useUser = () => {
  const dispatch = useDispatch();
  const user = useSelector((state) => state.user.data);
  const loading = useSelector((state) => state.user.loading);
  const error = useSelector((state) => state.user.error);
  const status = useSelector((state) => state.user.status);
  const httpStatus = useSelector((state) => state.user.httpStatus);

  const getUser = (token) => {
    dispatch(fetchUser(token));
  };

  return { user, loading, error, status, httpStatus, getUser };
};
